import { connect } from "react-redux";
import LocationEditView from "./LocationEditView";
import {
  addLocation,
  editLocation,
  deleteLocation,
  getSelectedLocationId,
  selectSelectedLocation
} from "../locations/LocationsState";
import LadsState from "../lads/LadsState";

function mapStateToProps(state) {
  const locationID = getSelectedLocationId(state);
  return {
    ...state.maps,
    lads: LadsState.selectors.getLadsList(state),
    locations: state.locations.data,
    locationID,
    selectedLocation: selectSelectedLocation(state),
    H: state.maps.H,
    platform: state.maps.platform
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addLocation: data => dispatch(addLocation(data)),
    editLocation: (id, data) => dispatch(editLocation(id, data)),
    deleteLocation: id => dispatch(deleteLocation(id)),
    pushLocationsScreen: () => dispatch({ type: "LOCATION_MANAGEMENT" })
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationEditView);



// WEBPACK FOOTER //
// ./src/modules/location-edit/LocationEditViewContainer.js